module.exports = Em.Controller.extend({
    queryParams: ['locale', 'target', 'email', 'yourName', 'companyName', 'phone', 'drip_email']
})
